import notificationsSaga from './notifications.saga';

export default notificationsSaga;
